import { useNavigate } from "react-router-dom";
import { EuiButton, EuiFlexItem, EuiFlexGroup, EuiSpacer, EuiShowFor } from "@elastic/eui";
import FDEmptyPrompt from "components/FDEmptyPrompt";

const Unauthorized = () => {
  const navigate = useNavigate();
  const onClick = () => {
    navigate("/");
  };
  const title = "Access not authorized";
  const body = (
    <span>
      Additional access privileges are needed to perform <br /> this action
    </span>
  );

  const retryTxt = "Back To Home Page";
  const xl = (
    <FDEmptyPrompt
      Body={
        <>
          <EuiSpacer size="l" />
          <EuiFlexGroup responsive={false}>
            <EuiFlexItem grow={false}>{body}</EuiFlexItem>
          </EuiFlexGroup>
          <EuiSpacer size="l" />
          <EuiFlexGroup responsive={false}>
            <EuiFlexItem grow={false}>
              <EuiButton fill onClick={onClick}>
                {retryTxt}
              </EuiButton>
            </EuiFlexItem>
          </EuiFlexGroup>
        </>
      }
      FullWidth={true}
      ImageCls="unauthorized-logo "
      ImageSrc="/ui/images/logos/unauthorized"
      Size="xl"
      Title={title}
      TitleSize="m"
    />
  );
  const l = (
    <FDEmptyPrompt
      Body={
        <>
          <EuiSpacer size="l" />
          <EuiFlexGroup responsive={false}>
            <EuiFlexItem grow={false}>{body}</EuiFlexItem>
          </EuiFlexGroup>
          <EuiSpacer size="l" />
          <EuiFlexGroup responsive={false}>
            <EuiFlexItem grow={false}>
              <EuiButton fill onClick={onClick}>
                {retryTxt}
              </EuiButton>
            </EuiFlexItem>
          </EuiFlexGroup>
        </>
      }
      FullWidth={true}
      ImageSrc="/ui/images/logos/unauthorized"
      Size="l"
      Title={title}
      TitleSize="m"
    />
  );

  const m = (
    <FDEmptyPrompt
      Body={
        <>
          <EuiSpacer size="l" />
          <EuiFlexGroup responsive={false}>
            <EuiFlexItem grow={false}>{body}</EuiFlexItem>
          </EuiFlexGroup>
          <EuiSpacer size="l" />
          <EuiFlexGroup responsive={false}>
            <EuiFlexItem grow={false}>
              <EuiButton fill onClick={onClick}>
                {retryTxt}
              </EuiButton>
            </EuiFlexItem>
          </EuiFlexGroup>
        </>
      }
      FullWidth={true}
      ImageCls="unauthorized-logo "
      ImageSrc="/ui/images/logos/unauthorized"
      Size="m"
      Title={title}
      TitleSize="m"
    />
  );
  const s = (
    <FDEmptyPrompt
      Body={
        <>
          <EuiSpacer size="l" />
          <EuiFlexGroup responsive={false}>
            <EuiFlexItem grow={false}>
              Additional access privileges are needed to perform this action
            </EuiFlexItem>
          </EuiFlexGroup>
          <EuiSpacer size="l" />
          <EuiFlexGroup responsive={false}>
            <EuiFlexItem grow={false}>
              <EuiButton fill onClick={onClick}>
                {retryTxt}
              </EuiButton>
            </EuiFlexItem>
          </EuiFlexGroup>
        </>
      }
      FullWidth={true}
      ImageCls="unauthorized-logo "
      ImageSrc="/ui/images/logos/unauthorized"
      Size="s"
      Title={title}
      TitleSize="s"
    />
  );

  const xs = (
    <FDEmptyPrompt
      Body={
        <>
          <EuiSpacer size="m" />
          <EuiFlexGroup responsive={false}>
            <EuiFlexItem grow={false}>
              Additional access privileges are needed to perform this action
            </EuiFlexItem>
          </EuiFlexGroup>
          <EuiSpacer size="m" />
          <EuiFlexGroup responsive={false}>
            <EuiFlexItem grow={false}>
              <EuiButton fill onClick={onClick} size="s">
                {retryTxt}
              </EuiButton>
            </EuiFlexItem>
          </EuiFlexGroup>
        </>
      }
      FullWidth={false}
      ImageCls="unauthorized-logo "
      ImageSrc="/ui/images/logos/unauthorized"
      Size="xs"
      Title="Access not authorized"
      TitleSize="xs"
    />
  );
  return (
    <>
      <EuiShowFor sizes={["xl"]}>{xl}</EuiShowFor>
      <EuiShowFor sizes={["l"]}>{l}</EuiShowFor>
      <EuiShowFor sizes={["m"]}>{m}</EuiShowFor>
      <EuiShowFor sizes={["s"]}>{s}</EuiShowFor>
      <EuiShowFor sizes={["xs"]}>{xs}</EuiShowFor>
    </>
  );
};

export default Unauthorized;
